import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  samplers: null,
  samplerCount: 0,
  districts: [],
  states: [],
  agencies: [],
  addSamplerInProgress: false,
  editSamplerInProgress: false,
  districtsOfMultipleStates: [],
};

const samplerListingSlice = createSlice({
  name: "samplerListing",
  initialState,
  reducers: {
    fetchSamplers(state, action) {
      state.tableLoading = true;
      state.samplers = null;
    },
    fetchSamplersSuccess(state, action) {
      state.samplers = action.payload.data.document;
      state.samplerCount = action.payload.data.paginationMetadata.total;
      state.tableLoading = false;
    },
    fetchSamplersFailure(state, action) {
      state.tableLoading = false;
    },
    addSampler(state, action) {
      state.addSamplerInProgress = true;
    },
    addSamplerSuccess(state, action) {
      state.addSamplerInProgress = false;
    },
    addSamplerFailure(state, action) {
      state.addSamplerInProgress = false;
    },
    editSampler(state, action) {
      state.editSamplerInProgress = true;
    },
    editSamplerSuccess(state, action) {
      state.editSamplerInProgress = false;
    },
    editSamplerFailure(state, action) {
      state.editSamplerInProgress = false;
      state.error = action.payload.error;
    },
    fetchDistricts(state, action) {
      state.loading = true;
    },
    fetchDistrictsSuccess(state, action) {
      state.districts = action.payload.data.districts;
      state.loading = false;
    },
    fetchDistrictsFailure(state, action) {
      state.loading = false;
    },
    fetchStates(state, action) {
      state.loading = true;
    },
    fetchStatesSuccess(state, action) {
      state.states = action.payload.data.document;
      state.loading = false;
    },
    fetchStatesFailure(state, action) {
      state.loading = false;
    },
    fetchAgencies(state, action) {
      state.loading = true;
    },
    fetchAgenciesSuccess(state, action) {
      state.agencies = action.payload.data.documents;
      state.loading = false;
    },
    fetchAgenciesFailure(state, action) {
      state.loading = false;
    },
    // initializeState(state, action) {
    //   state.districts = [];
    //   state.states = [];
    //   state.agencies = [];
    // },

    fetchDistrictsOfMultipleStates(state, action) {},
    fetchDistrictsOfMultipleStatesSuccess(state, action) {
      state.districtsOfMultipleStates = action.payload.data?.states
        ?.map((s) => s.districts)
        ?.flat();
    },
    fetchDistrictsOfMultipleStatesFailure(state, action) {
      state.districtsOfMultipleStates = [];
    },
  },
});

export const { actions, reducer, name: sliceKey } = samplerListingSlice;
